import update from "immutability-helper";
import {
  //Загрузка информации о вопросе
  QUESTION_INFO_LOADING_START,
  QUESTION_INFO_LOADED_SUCCESSFULLY,
  QUESTION_INFO_LOADING_FAILED,
  //Удаление вопроса
  QUESTION_DELETION_START,
  QUESTION_DELETED_SUCCESSFULLY,
  QUESTION_DELETION_FAILED,
  //Изменение видимости родительского вопроса
  QUESTION_VISIBILITY_CHANGED_SUCCESSFULLY,
  //Изменение видимости подвопроса
  SUBQUESTION_VISIBILITY_CHANGED_SUCCESSFULLY,
  //Перемещение подвопроса по списку
  CHILDREN_SORTING_START,
  CHILDREN_SORTING_FAILED,
} from '../actions/questionInfo';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  question: {},
};

export default function (state = INITIAL_STATE, action) { 
  switch (action.type) {
    //Загрузка информации о вопросе
    case QUESTION_INFO_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        question: {},
      };
    case QUESTION_INFO_LOADED_SUCCESSFULLY:
      return {
        ...state,
        ready: true,
        loading: false,
        question: action.payload.question,
      };
    case QUESTION_INFO_LOADING_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    //Удаление вопроса
    case QUESTION_DELETION_START:
      return {
        ...state,
        ready: false,
        loading: true,
      };
    case QUESTION_DELETED_SUCCESSFULLY:
      return {
        ...state,
        ready: false,
        loading: false,
        question: {},
      };
    case QUESTION_DELETION_FAILED:
    case CHILDREN_SORTING_FAILED:
      return {
        ...state,
        ready: true,
        loading: false,
      };
    //Изменение видимости родительского вопроса
    case QUESTION_VISIBILITY_CHANGED_SUCCESSFULLY:
      return update(state, {
        question: {
          is_visible: {$set: action.payload.status},
        }
      });
    //Изменение видимости подвопроса
    case SUBQUESTION_VISIBILITY_CHANGED_SUCCESSFULLY:
      return update(state, {
        question: {
          children: {
            [action.payload.questionIndex]: {
              is_visible: {$set: action.payload.status},
            }
          }
        }
      });
    //Перемещение подвопроса по списку
    case CHILDREN_SORTING_START:
      return {
        ...state,
        ready: false,
        loading: true,
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}